module.exports = __webpack_public_path__ + "static/media/Checkmark.08b33c5f.svg";